<template v-if="this.scoreData">
  <b-card-body >
    <b-row align-v="center" v-if="this.scoreData['totalScore'] !== undefined">
      <b-col md="auto" >
        <h3>Total</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.scoreData['totalScore']).toFixed(1) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" v-if="this.scoreData['idleScore'] !== undefined">
      <b-col md="auto" >
        <h3>Idle</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.scoreData['idleScore']).toFixed(1) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" v-if="this.scoreData['cruiseScore'] !== undefined">
      <b-col md="auto" >
        <h3>Cruise</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.scoreData['cruiseScore']).toFixed(1) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" v-if="this.scoreData['coastScore'] !== undefined">
      <b-col md="auto" >
        <h3>Coast</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.scoreData['coastScore']).toFixed(1) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" v-if="this.scoreData['speedScore'] !== undefined">
      <b-col md="auto" >
        <h3>Over speed</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.scoreData['speedScore']).toFixed(1) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" v-if="this.scoreData['rpmScore'] !== undefined">
      <b-col md="auto" >
        <h3>Over rpm</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.scoreData['rpmScore']).toFixed(1) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" v-if="this.scoreData['harshAccelerationScore'] !== undefined">
      <b-col md="auto" >
        <h3>Harsh acceleration</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.scoreData['harshAccelerationScore']).toFixed(1) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" v-if="this.scoreData['harshBrakeScore'] !== undefined">
      <b-col md="auto" >
        <h3>Harsh brake</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.scoreData['harshBrakeScore']).toFixed(1) }}</h5>
      </b-col>
    </b-row>
  </b-card-body>
</template>

<script>
export default {
  name: "score-card",
  props: {
    scoreData: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>
